var _circle, _circle2, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalTelekomDe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 32,
    height: 32,
    fill: "#E20074"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8425 43.2214H47.9258V47.1338H51.8425V43.2214ZM40.0222 43.2214H36.1055V47.1338H40.0222V43.2214Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5115 49.5138C42.5115 50.7582 42.3295 51.5643 41.9653 51.9386C41.6458 52.2585 41.1346 52.4505 40.3999 52.524C40.1794 52.5432 39.8056 52.5496 39.2785 52.5496V53.6405H48.7156V52.5496C48.1544 52.5643 47.5931 52.5279 47.0384 52.4409C46.707 52.3901 46.3984 52.2411 46.1524 52.013C45.9064 51.7849 45.7343 51.4882 45.6583 51.1613C45.5407 50.6204 45.4902 50.067 45.5082 49.5138V35.2654C47.1076 35.3101 48.36 35.8433 49.2651 36.8649C50.117 37.8374 50.642 39.3302 50.8401 41.3435L51.8592 41.1515L51.6707 34.3376H36.3362L36.1445 41.1515L37.1668 41.3275C37.3585 39.3206 37.891 37.8278 38.7642 36.8489C39.6715 35.8316 40.9291 35.2984 42.5371 35.2494V49.5138H42.5115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalTelekomDe);
export default __webpack_public_path__ + "static/media/logoModalTelekomDE.4a26f633f2cd760536fe002843ff98f3.svg";
export { ForwardRef as ReactComponent };